export default {
  tier_0: 'Tier 0',
  tier_1: 'Tier 1',
  tier_2: 'Tier 2',
  tier_3: 'Tier 3',
  t3: 'T3', // Tier 3 - This is a mistake when we set Tier 3 on Prod
  tier_3_unverified: 'Tier 3 - Unverified Pilot',
}
